const getBasePath = (path) => path.substring(0, path.lastIndexOf('/') + 1);

export default getBasePath;
